import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
// redux
import { store, persistor } from './services/redux/store';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import { LiveUpdate } from '@capawesome/capacitor-live-update';

// Notify Capawesome that the app is ready (prevents rollback)
LiveUpdate.ready();

// Ensure splash screen is shown at startup
if (Capacitor.getPlatform() !== 'web') {
  SplashScreen.show({
    showDuration: 0,
    autoHide: false
  });
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </ReduxProvider>
  </React.StrictMode>
);

// Splash screen is now controlled in App.tsx after initialization is complete